import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router";
export { };

type AuthContextType = {
    isAuthenticated: boolean,
    token: string | null,
    setToken: React.Dispatch<React.SetStateAction<string | null>>
    loading: boolean
};

const AuthContext = createContext<AuthContextType>({ isAuthenticated: false, token: null, setToken: () => { }, loading: true })

export const useAuth = () => {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error("AuthContext must be inside it's context")
    }
    return context
}

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [token, setToken] = useState<any>()

    // const storedToken = (localStorage.getItem("token"))
    const storedToken = (localStorage.getItem("accessToken"))
    useEffect(() => {
        if (storedToken) {
            // console.log(storedToken, "............");
            setToken(storedToken)
            setIsAuthenticated(true)
        } else {
            setIsAuthenticated(false)
        }
        setLoading(false)
    }, [storedToken])

    // console.log('====================================');
    // console.log(token, isAuthenticated);
    // console.log('====================================');
    // useEffect(() => {
    //     setIsAuthenticated(!!token)
    // }, [token])

    return (
        <AuthContext.Provider value={{ isAuthenticated, token, setToken, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    )
} 